const columnStyle = {
  headerStyle : {textAlign : "center"}, cellStyle : {textAlign : "center"}
}

export const schema = [
  { name: "code", label: "星网授权编号", type: "input" },
  { name: "projname", label: "授权项目名称", type: "input" },
  { name: "projnumber", label: "招标项目编号", type: "input" },
  { name: "authcompany", label: "授权公司名称", type: "input" },
  { name: "projownercompany", label: "项目归属合作伙伴", type: "input" },
  { name: "contact", label: "星网接口人", type: "input" },
];

export const columns = (render) => [
  { title: '星网授权编号', field: 'code', ...columnStyle},
  { title: '授权项目名称', field: 'projname', ...columnStyle},
  //{ title: '创建时间', field: 'ctime', ...columnStyle},
  { title: "招标项目编号", field : "projnumber", ...columnStyle},
  { title: "授权公司名称", field : "authcompany", ...columnStyle},
  { title: "授权有效期", field : "validitytime", ...columnStyle},
  { title: "项目归属合作伙伴", field : "projownercompany", ...columnStyle},
  { title: "星网接口人", field : "contact", ...columnStyle},
  { title: "星网授权日期", field : "authtime", ...columnStyle},
  { title: "操作", render, ...columnStyle}
];

export const formSchema = [
  { name: "code", label: "星网授权编号", type: "input", validate : {required : "不能为空"} },
  { name: "projname", label: "授权项目名称", type: "input", validate : {required : "不能为空"} },
  { name: "projnumber", label: "招标项目编号", type: "input"},
  { name: "authcompany", label: "授权公司名称", type: "input", validate : {required : "不能为空"} },
  { name: "validitytime", label: "授权有效期", type: "input", validate : {required : "不能为空"} },
  { name: "projownercompany", label: "项目归属合作伙伴", type: "input", validate : {required : "不能为空"} },
  { name: "contact", label: "星网接口人", type: "input", validate : {required : "不能为空"} },
  { name: "authtime", label: "星网授权日期", type: "time", validate : {required : "不能为空"} },
  { name: "fileid", label: "授权函", type: "file", validate : {required : "不能为空"} },
  // {
  //   name: "productLine", label: "产品线", type: "select", selectSchema: [
  //     { value: "R1", label: "通讯" },
  //     { value: "R2", label: "智慧科技" },
  //   ]
  // },
];